import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../context/AuthProvider";

const PrivateRoute = () => {
  const { user, loading } = useAuthContext();

  if (loading) return <h1>Cargando...</h1>; // ✅ Esperamos a que termine de cargar

  return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;